<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><a id="page_1"><img alt="Image" src="images/common1.jpg"/>  PART ONE  <img alt="Image" src="images/common1.jpg"/></a></p><a id="page_1">
<p class="part1"><i>Fall Semester<br/>The Brook-Haven School</i><br/>1983</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part01.vue?0b494dbd